import React from 'react'

function Question({ data, index, action }) {

    const questionText = data.question;
    const answers = data.answers;

    return (
        <div className="question">
            <p className="question-text">{questionText}</p>
            {answers.map(ans =>
                <div className="radio-option" key={`${index}-${ans.id}`}>
                    <input type="radio" name={`${index}-${ans.id}`} value={ans.checked} checked={ans.checked} onChange={() => action(index, ans.id)} /><label htmlFor="empleoactual">{ans.text}</label>
                </div>
            )}
        </div>
    )
}

export default Question